import React, { useEffect, useState } from 'react'

export default function RoleSystemToc({ items = [] }) {
  const [activeId, setActiveId] = useState('')
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    if (!items.length) return undefined

    const ids = items.map((it) => it.id)
    const elements = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean)

    if (!elements.length) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)
        if (visible[0]?.target?.id) {
          setActiveId(visible[0].target.id)
        }
      },
      { rootMargin: '-20% 0px -65% 0px', threshold: [0, 0.25, 0.5, 1] }
    )

    elements.forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [items])

  if (!items.length) return null

  const handleClick = (id) => {
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      setActiveId(id)
    }
    setMobileOpen(false)
  }

  const nav = (
    <nav className="role-system-toc__nav" aria-label="Índice del volumen">
      <ul className="role-system-toc__list">
        {items.map((item) => (
          <li
            key={item.id}
            className={`role-system-toc__item role-system-toc__item--h${item.level}${
              activeId === item.id ? ' role-system-toc__item--active' : ''
            }`}
          >
            <button type="button" className="role-system-toc__link" onClick={() => handleClick(item.id)}>
              {item.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  )

  return (
    <aside className="role-system-toc">
      <div className="role-system-toc__mobile">
        <button
          type="button"
          className="role-system-toc__toggle"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
        >
          Índice del volumen
          <span aria-hidden="true">{mobileOpen ? '▴' : '▾'}</span>
        </button>
        {mobileOpen ? nav : null}
      </div>
      <div className="role-system-toc__desktop">
        <p className="role-system-toc__label">Índice</p>
        {nav}
      </div>
    </aside>
  )
}
